export const translations = {
  fr: {
    brand: "Maison Marigold",
    brandTagline: "Souffle de l'Inde, à Paris",
    nav: {
      spices: "Épicerie",
      saffron: "Safran",
      textiles: "Textiles",
      deco: "Art Déco",
      oils: "Huiles",
      story: "Notre Histoire",
      artisans: "Artisans",
      journal: "Journal",
      contact: "Contact",
    },
    hero: {
      overline: "Maison fondée en 2024 — Paris",
      title: "Le fil invisible",
      titleAccent: "entre deux mondes.",
      sub: "Des villages d'artisans de l'Inde aux intérieurs parisiens — textiles, artefacts, bijoux et safran portés par la main et la mémoire.",
      cta: "Découvrir la collection",
      cta2: "Notre histoire",
    },
    sections: {
      featured: "Pièces choisies",
      featuredSub: "Une sélection limitée, renouvelée chaque saison.",
      categories: "Univers",
      story: "Un fil tendu entre Paris et l'Inde",
      values: "Notre engagement",
      journal: "Chroniques d'atelier",
      saffron: "Or rouge du Cachemire",
    },
    categories: {
      textiles: "Textiles",
      deco: "Art décoratif",
      saffron: "Safran",
      spices: "Épicerie",
      oils: "Huiles essentielles",
    },
    cats: {
      textiles: { name: "Textiles", desc: "Block-print, pashmina, banarasi, kalamkari — tissés à la main" },
      deco: { name: "Art décoratif", desc: "Madhubani, Warli, miniatures Mughal, Tanjore à la feuille d'or" },
      saffron: { name: "Safran", desc: "Or rouge du Cachemire, récolté à la main à Pampore" },
      spices: { name: "Épicerie", desc: "Cardamome, cannelle vraie, cumin, poivre Tellicherry, curcuma · thé Darjeeling, café Malabar" },
      oils: { name: "Huiles essentielles", desc: "Santal, rose absolue, jasmin sambac, vétiver, kewda · et Mitti attar, la pluie indienne en flacon" },
    },
    subcats: {
      textiles: {
        all: "Toutes les pièces",
        "block-print": "Block-print",
        "pashmina": "Pashmina",
        "banarasi": "Banarasi",
        "kalamkari": "Kalamkari",
      },
      deco: {
        all: "Toutes les œuvres",
        "madhubani": "Madhubani",
        "warli": "Warli",
        "miniature": "Miniature",
        "tanjore": "Tanjore",
      },
    },
    saffron: {
      overline: "Maison · Épices rares",
      title: "L'or rouge",
      titleAccent: "du Cachemire.",
      lede: "Dix-sept jours de floraison par an. Cent cinquante mille fleurs pour un kilogramme. Trois stigmates par fleur, cueillis à la main avant le soleil. Voici le safran de Pampore — le plus concentré du monde, celui que les empereurs Mughal réservaient à leur table.",
      ledeShort: "Cueilli à la main à Pampore. Trié par les femmes du village de Lethpora. Importé en circuit court — quatre semaines de la fleur à votre cuisine.",
      pillars: [
        { n: "01", title: "Origine certifiée", body: "Indice géographique protégé (IGP Kashmir Saffron, 2020). Le seul safran au monde reconnu pour sa teneur en safranal supérieure à 45." },
        { n: "02", title: "Récolte à la main", body: "Aucune machine. Chaque fleur est cueillie entre 5 h et 8 h du matin, ses trois stigmates extraits le jour même. Une femme récolte 60 grammes par saison." },
        { n: "03", title: "Trois qualités", body: "Mongra (stigmates seuls, premium), Lacha (stigmates + style jaune), Coffret trio. Chacun a son usage — du dessert royal au lait doré quotidien." },
        { n: "04", title: "Sans intermédiaire", body: "Achat direct à la coopérative de femmes de Lethpora. Prix juste. Traçabilité au champ. Récolte 2025, datée sur chaque flacon." },
      ],
      ritual: {
        title: "Le rituel de l'infusion",
        body: "Le safran ne se cuit pas. On l'éveille. Faites infuser 5 à 6 stigmates dans une cuillère de lait tiède pendant vingt minutes, puis incorporez à votre préparation — riz, pâtisserie, soupe d'hiver. La couleur, le parfum et la note légèrement miellée se révèlent alors pleinement.",
      },
      ctaShop: "Découvrir les safrans",
    },
    storyBlock: {
      overline: "Notre récit",
      title: "Vasudhaiva Kutumbakam",
      subtitle: "« Le monde entier est une seule famille »",
      body1: "Cette phrase, gravée à l'entrée du parlement indien, est notre boussole. Maison Marigold est née d'une conviction simple : les objets faits à la main portent en eux la voix de ceux qui les ont façonnés. En les invitant dans vos intérieurs parisiens, vous prolongez la vie d'un geste, d'un village, d'une mémoire.",
      body2: "Nous travaillons directement avec quarante-sept ateliers répartis dans douze états indiens. Pas d'intermédiaires. Une traçabilité totale. Et la promesse que chaque pièce raconte son histoire.",
      learnMore: "Lire la suite",
    },
    values: {
      v1: { title: "Source directe", body: "Achats directement auprès des artisans. Aucun intermédiaire, prix justes." },
      v2: { title: "Traçabilité totale", body: "Chaque pièce nommée, son atelier identifié, son origine documentée." },
      v3: { title: "Livraison en Europe", body: "Expédié de Paris sous 5 jours ouvrés. Emballage compostable." },
      v4: { title: "Édition limitée", body: "Pièces uniques ou en très petites séries. Quand c'est parti, c'est parti." },
    },
    product: {
      addToCart: "Ajouter au panier",
      addToWishlist: "Ajouter aux favoris",
      removeFromWishlist: "Retirer des favoris",
      details: "Détails",
      origin: "Origine",
      materials: "Matériaux",
      artisan: "Artisan",
      story: "L'histoire de la pièce",
      backToShop: "Retour à la boutique",
      youMayAlsoLike: "Vous pourriez aussi aimer",
    },
    cart: {
      title: "Votre panier",
      empty: "Votre panier est vide.",
      emptyCta: "Découvrir la collection",
      subtotal: "Sous-total",
      checkout: "Demander un devis",
      checkoutNote: "Nos pièces étant en édition limitée, les tarifs et délais vous sont communiqués sur demande. Votre sélection nous parviendra sur WhatsApp.",
      remove: "Retirer",
      qty: "Quantité",
      quoteIntro: "Bonjour Maison Marigold, je souhaiterais un devis pour les pièces suivantes :",
      quoteOutro: "Merci de me communiquer les tarifs et délais de livraison.",
    },
    wishlist: {
      title: "Vos favoris",
      empty: "Aucun favori pour le moment.",
    },
    newsletter: {
      title: "Recevez nos chroniques",
      sub: "Une lettre saisonnière. Histoires d'atelier, nouvelles pièces, accès anticipé.",
      placeholder: "Votre adresse email",
      cta: "S'abonner",
      success: "Merci, vous êtes inscrit·e.",
      error: "Une erreur est survenue. Réessayez.",
    },
    contact: {
      title: "Écrivez-nous",
      sub: "Pour connaître le prix d'une pièce, son histoire ou demander une commande sur-mesure — écrivez-nous, nous répondons sous 48 heures.",
      name: "Votre nom",
      email: "Votre email",
      message: "Votre message",
      send: "Envoyer",
      success: "Message envoyé. Réponse sous 48h.",
    },
    artisans: {
      title: "Les mains derrière les pièces",
      sub: "Quarante-sept ateliers. Douze états indiens. Une seule histoire — la vôtre, prolongée.",
      meet: "Rencontrer l'atelier",
    },
    footer: {
      tagline: "Artefacts indiens, safran de Pampore et épices rares pour intérieurs européens.",
      shop: "Boutique",
      house: "Maison",
      help: "Aide",
      story: "Notre histoire",
      artisans: "Artisans",
      saffron: "Safran",
      journal: "Journal",
      contact: "Contact",
      shipping: "Livraison",
      returns: "Retours",
      faq: "FAQ",
      rights: "Tous droits réservés.",
    },
    common: {
      from: "À partir de",
      eur: "€",
      readMore: "Lire la suite",
      explore: "Explorer",
      shopAll: "Tout voir",
    },
  },
  en: {
    brand: "Maison Marigold",
    brandTagline: "The breath of India, in Paris",
    nav: {
      spices: "Pantry",
      saffron: "Saffron",
      textiles: "Textiles",
      deco: "Deco Art",
      oils: "Oils",
      story: "Our Story",
      artisans: "Artisans",
      journal: "Journal",
      contact: "Contact",
    },
    hero: {
      overline: "Founded in 2024 — Paris",
      title: "The invisible thread",
      titleAccent: "between two worlds.",
      sub: "From village artisans of India to Parisian interiors — textiles, artefacts, jewellery and saffron carried by hand and memory.",
      cta: "Discover the collection",
      cta2: "Our story",
    },
    sections: {
      featured: "Curated pieces",
      featuredSub: "A limited selection, renewed each season.",
      categories: "Universes",
      story: "A thread between Paris and India",
      values: "Our commitment",
      journal: "Workshop chronicles",
      saffron: "Red gold of Kashmir",
    },
    categories: {
      textiles: "Textiles",
      deco: "Decorative Art",
      saffron: "Saffron",
      spices: "Pantry",
      oils: "Essential Oils",
    },
    cats: {
      textiles: { name: "Textiles", desc: "Block-print, pashmina, banarasi, kalamkari — hand-woven" },
      deco: { name: "Decorative Art", desc: "Madhubani, Warli, Mughal miniatures, gold-leaf Tanjore" },
      saffron: { name: "Saffron", desc: "Red gold of Kashmir, hand-picked in Pampore" },
      spices: { name: "Pantry", desc: "Cardamom, true cinnamon, cumin, Tellicherry pepper, turmeric · Darjeeling tea, Malabar coffee" },
      oils: { name: "Essential Oils", desc: "Sandalwood, rose absolute, sambac jasmine, vetiver, kewda · and Mitti attar, the Indian rain bottled" },
    },
    subcats: {
      textiles: {
        all: "All pieces",
        "block-print": "Block-print",
        "pashmina": "Pashmina",
        "banarasi": "Banarasi",
        "kalamkari": "Kalamkari",
      },
      deco: {
        all: "All works",
        "madhubani": "Madhubani",
        "warli": "Warli",
        "miniature": "Miniature",
        "tanjore": "Tanjore",
      },
    },
    saffron: {
      overline: "Maison · Rare spices",
      title: "The red gold",
      titleAccent: "of Kashmir.",
      lede: "Seventeen days of bloom a year. One hundred and fifty thousand flowers for a single kilogram. Three stigmas per flower, picked by hand before sunrise. This is Pampore saffron — the most concentrated in the world, the one the Mughal emperors reserved for their table.",
      ledeShort: "Hand-picked in Pampore. Sorted by the women of Lethpora village. Imported in a short circuit — four weeks from flower to your kitchen.",
      pillars: [
        { n: "01", title: "Certified origin", body: "Protected Geographical Indication (Kashmir Saffron GI, 2020). The only saffron in the world recognised for its safranal content above 45." },
        { n: "02", title: "Hand-harvested", body: "No machinery. Each flower is picked between 5 am and 8 am, its three stigmas extracted the same day. A woman harvests 60 grams per season." },
        { n: "03", title: "Three grades", body: "Mongra (whole stigmas, premium), Lacha (stigmas + yellow style), Trio gift box. Each has its use — from royal dessert to daily golden milk." },
        { n: "04", title: "No middlemen", body: "Bought directly from the women's cooperative of Lethpora. Fair price. Field-level traceability. 2025 harvest, dated on every vial." },
      ],
      ritual: {
        title: "The infusion ritual",
        body: "Saffron is not cooked. It is awakened. Steep 5 to 6 stigmas in a spoonful of warm milk for twenty minutes, then fold into your preparation — rice, pastry, winter soup. The colour, the perfume and the lightly honeyed note then reveal themselves fully.",
      },
      ctaShop: "Discover the saffrons",
    },
    storyBlock: {
      overline: "Our narrative",
      title: "Vasudhaiva Kutumbakam",
      subtitle: '"The whole world is one family"',
      body1: "This phrase, inscribed at the entrance of the Indian parliament, is our compass. Maison Marigold was born of a simple conviction: handmade objects carry in them the voice of those who shaped them. By inviting them into your Parisian interiors, you extend the life of a gesture, a village, a memory.",
      body2: "We work directly with forty-seven workshops across twelve Indian states. No intermediaries. Full traceability. And the promise that every piece tells its story.",
      learnMore: "Read more",
    },
    values: {
      v1: { title: "Direct sourcing", body: "Bought directly from the artisans. No middlemen, fair prices." },
      v2: { title: "Full traceability", body: "Each piece named, its workshop identified, its origin documented." },
      v3: { title: "European delivery", body: "Shipped from Paris within 5 working days. Compostable packaging." },
      v4: { title: "Limited editions", body: "Unique pieces or very small series. Once gone, gone for good." },
    },
    product: {
      addToCart: "Add to cart",
      addToWishlist: "Add to wishlist",
      removeFromWishlist: "Remove from wishlist",
      details: "Details",
      origin: "Origin",
      materials: "Materials",
      artisan: "Artisan",
      story: "The story of the piece",
      backToShop: "Back to shop",
      youMayAlsoLike: "You may also like",
    },
    cart: {
      title: "Your basket",
      empty: "Your basket is empty.",
      emptyCta: "Discover the collection",
      subtotal: "Subtotal",
      checkout: "Request a quote",
      checkoutNote: "Our pieces are limited editions — pricing and delivery are shared on request. Your selection will reach us via WhatsApp.",
      remove: "Remove",
      qty: "Quantity",
      quoteIntro: "Hello Maison Marigold, I would like a quote for the following pieces:",
      quoteOutro: "Please share pricing and delivery details. Thank you.",
    },
    wishlist: {
      title: "Your wishlist",
      empty: "No favourites yet.",
    },
    newsletter: {
      title: "Receive our chronicles",
      sub: "A seasonal letter. Workshop stories, new pieces, early access.",
      placeholder: "Your email address",
      cta: "Subscribe",
      success: "Thank you, you're subscribed.",
      error: "Something went wrong. Try again.",
    },
    contact: {
      title: "Write to us",
      sub: "To learn the price of a piece, its story, or to request a custom order — write to us. We reply within 48 hours.",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send",
      success: "Message sent. Reply within 48h.",
    },
    artisans: {
      title: "The hands behind the pieces",
      sub: "Forty-seven workshops. Twelve Indian states. One story — yours, extended.",
      meet: "Meet the workshop",
    },
    footer: {
      tagline: "Indian artefacts, Pampore saffron and rare spices for European interiors.",
      shop: "Shop",
      house: "House",
      help: "Help",
      story: "Our story",
      artisans: "Artisans",
      saffron: "Saffron",
      journal: "Journal",
      contact: "Contact",
      shipping: "Shipping",
      returns: "Returns",
      faq: "FAQ",
      rights: "All rights reserved.",
    },
    common: {
      from: "From",
      eur: "€",
      readMore: "Read more",
      explore: "Explore",
      shopAll: "View all",
    },
  },
};
